import React from 'react';
import { useDispatch } from 'react-redux';
import VendorDetailsForm from '../../components/vendorDetailsComponents/VendorDetailsForm';
import { setHeaderName } from '../../redux/actions/userActions';

const VendorDetailsFormPage = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Vendor'));
    return <VendorDetailsForm />
}

export default VendorDetailsFormPage